import React from 'react'
import Modal from '@/components/ui/Modal'
import TitleInput from '@/components/ui/TitleInput'
import { ReactComponent as SecretIcon } from '@/assets/icons/secret.svg'
import Button from '@/components/ui/Buttons/Button'
import { Form, Formik } from 'formik'
import classes from './SecretModal.module.scss'
import { Puff } from '@/components/ui/Loaders'
import { StudioSecret } from '@/lib/react-query'
import { useForm } from './SecretModal.hooks'
import Input from '@/components/ui/Input'
import { getSlug } from '@/utils/slug'
import CopyAdornment from '@/components/ui/CopyAdornment'
import { SecretValueInput } from '@/features/secrets'
import FormHelperText from '@/components/ui/FormHelperText'

export type SecretModalProps = {
  secret?: StudioSecret
  projectId: number
  onClose: () => void
}

export const SecretModal = ({ secret, projectId, onClose }: SecretModalProps) => {
  const formikProps = useForm(secret, projectId, onClose)

  return (
    <Formik {...formikProps}>
      {({ handleSubmit, values, setFieldValue, handleBlur, isSubmitting, errors, isValid }) => {
        return (
        <Form>
          <Modal onClose={onClose} isOpen>
            <Modal.Header>
              <div>
                <Modal.Icon>
                  <SecretIcon />
                </Modal.Icon>
                <TitleInput
                  placeholder={'New secret'}
                  name={'name'}
                  onSave={(value) => setFieldValue('name', value)}
                  onBlur={handleBlur}
                  value={values.name}
                />
              </div>
              <div>
                <Modal.Close onClick={onClose} />
              </div>
            </Modal.Header>
            <Modal.Content>
              <div className={classes.content}>
                <div>
                  <Input
                    name={'slug'}
                    value={getSlug(values.name)}
                    disabled
                    endAdornment={<CopyAdornment value={getSlug(values.name)} />}
                    color={errors.slug ? "danger" : "neutral"}
                    error={!!errors.slug}
                  />
                  {errors.slug && (
                    <>
                      <FormHelperText color="danger">{errors.slug}</FormHelperText>
                    </>
                  )}
                </div>
                <SecretValueInput label="" name={'value'} projectId={projectId} secretId={secret?.id} />
              </div>
            </Modal.Content>
            <Modal.Footer>
              <Button
                onClick={() => handleSubmit()}
                disabled={isSubmitting || !isValid}
                StartIcon={isSubmitting ? <Puff /> : undefined}
              >
                {secret ? 'Save secret' : 'Create secret'}
              </Button>
            </Modal.Footer>
          </Modal>
        </Form>
      )}}
    </Formik>
  )
}
